import originalImage from '../../../assets/old.png';
import modifiedImage from '../../../assets/new.jpg';

import style from "./ImgSlider.module.css"

import Slider from './Slider/index';

const slider = {
  delay: 2000,
  original: {
    url: originalImage,
    title: 'Original'
  },
  modified: {
    url: modifiedImage,
    title: 'Modified'
  }
};
const ImgSlider = () => {

  return (
    <div>
      <Slider {...slider} />
    </div>
  )
}

export default ImgSlider;